import { execa, type ExecaError } from 'execa';
import type { CheckResult, RuleSeverity } from '../types/index.js';

export interface ToolRunner {
  name: string;
  isInstalled(): Promise<boolean>;
  getVersion(): Promise<string | null>;
  run(cwd: string, files?: string[]): Promise<CheckResult[]>;
}

export async function checkCommand(command: string): Promise<boolean> {
  try {
    await execa('which', [command]);
    return true;
  } catch {
    return false;
  }
}

export async function runCommand(
  command: string,
  args: string[],
  cwd: string
): Promise<{ stdout: string; stderr: string; exitCode: number }> {
  try {
    const result = await execa(command, args, { cwd, reject: false });
    return {
      stdout: result.stdout as string,
      stderr: result.stderr as string,
      exitCode: result.exitCode ?? 0,
    };
  } catch (error) {
    const execaError = error as ExecaError;
    return {
      stdout: String(execaError.stdout ?? ''),
      stderr: String(execaError.stderr ?? ''),
      exitCode: typeof execaError.exitCode === 'number' ? execaError.exitCode : 1,
    };
  }
}

export function parseSeverity(level: string): RuleSeverity {
  const normalized = level.toLowerCase();
  if (normalized === 'error' || normalized === 'high' || normalized === 'critical') {
    return 'error';
  }
  if (normalized === 'warning' || normalized === 'warn' || normalized === 'medium') {
    return 'warn';
  }
  return 'info';
}
